import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {GetSlickGridProp} from "app/shared/models/get-slick-grid-prop";
import {SlickGridColumns} from "app/shared/models/slick-grid-columns";
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CodeName} from 'app/stocks/models/code-name';
import {StocksFilter} from 'app/stocks/models/stocks-filter';
import {ClearSelected} from 'app/stocks/models/clear-selected';
import {Focus} from 'app/stocks/models/focus';
import {StocksFiltersState} from 'app/stocks/models/stocks-filters-state';
import {SelectedFilter} from 'app/stocks/models/selected-filter';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {EventArgs} from 'app/slick-grid/models/event-args';
import {Formatters} from "../../../slick-grid/models/formatters";
import {ISubscription} from "rxjs/Subscription";
import {BlockFilter, BlockFilterGUID} from "../../models/block-filter";
import {ValidateData} from "../../models/validate-data";
import {StocksHelper} from "../../models/stocks-helper";
import {CommonService} from "../../../services/common.service";
import {StocksFilterGUID} from "../../models/stocks-filter";
import {StocksFiltersStateGUID} from "../../models/stocks-filters-state";
import {ClearSelectedGUID} from "../../models/clear-selected";
import * as Popper from 'popper.js/dist/umd/popper';
import {Observable} from "rxjs/Observable";
import {BTControl} from "../../models/b-t-control";
import OnRowsChangedEventData = Slick.Data.OnRowsChangedEventData;
import {FilterType} from "../../models/filter-type";
import {SCDataExchangeService} from "../../../supply-schedules/services/s-c-data-exchange.service";
import {ModuleTableName} from "../../../shared/models/module-table-name";
import {SlickGridProperties} from "../../../shared/models/slick-grid-properties";

type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'filter-search-code-name',
    templateUrl: './filter-search-code-name.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', './filter-search-code-name.component.css']
})
export class FilterSearchCodeNameComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                public readonly commonService: CommonService,
                public filterService: StocksFilterService,
                private changeDetector: ChangeDetectorRef){

        this.selectionModel = new Slick.RowSelectionModel<CodeName, Slick.Range[]>({selectActiveRow: false});

        this.gridView = new Slick.Data.DataView<CodeName>();
        this.gridView.onRowsChanged.subscribe((e: DOMEvent, args: OnRowsChangedEventData) => this.setCellStyles());
        this.gridView.getItemMetadata = this.metadata(this.gridView.getItemMetadata);
        this.columns = [
            {
                id: 'selected',
                field: 'selected',
                name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
                sortable: false,
                width: 25,
                maxWidth: 25,
                formatter: (r, c, v, col, dt) => Formatters.checkBoxFormatter(r, c, v, col, dt)
            },
            {id: 'code', field: 'code', name: 'Code', sortable: true, width: 50, minWidth: 50, maxWidth: 100, tooltip: 'auto', },
            {id: 'name', field: 'name', name: 'Name', sortable: true, width: 130, tooltip: 'auto'}
        ];

        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true,
            //forceFitColumns: true
            // enableAutoSizeColumns: true
            // autosizeColsMode: Slick.GridAutosizeColsMode.FitColsToViewport,
        };

        this.initialise();

        this.checkBoxHeader = null;
        this.viewInit = false;
        this.helper = new StocksHelper();
    }

    private initialise = (): void => {
        this.hasData = false;
        this.showGrid = false;
        this.showGridByScroll = false;

        this.allItemsQuantity = 0;
        this.selectedQuantity = 0;
        this.codesToRemove = [];
        this.data = [];
        this.filteredData = [];
        this.__inputData = '';
        this.prevInputData = '';
        this.develop = false;
        this.gridTop = -1000;
        this.messageTop = 0;
        this.notValidatedDataTop = 0;
        this.notValidatedDataRight = 0;
        this.height = 270;
        this.selected = false;
        this.inGrid = false;
        this.blockFilter = false;
        this.prevInputDataUpdate = false;
        this.notValidatedData = [];
        this.notValidatedDataShowScroll = false;
        this.messageShowScroll = false;
        this.hideMessageTime = 3000;
        this.slickScrollWidth = 12;
        this.gridHeight = 270;
        this.gridWidth = 360;
        this.mouseDown = false;
        this.validationResults = new EventEmitter<boolean>();

    };

    @HostListener('window:mousedown', ['$event']) onMouseDown(e: MouseEvent){
        this.hideGridOnClick(e);
    }

    @HostListener('window:mouseup', ['$event']) onMouseUp(e: MouseEvent){
        if (this.mouseDown){
            this.mouseDown = false;
            this.resizeGrid(true)
        }
    }

    // @HostListener('window:mousemove', ['$event']) onMouseMove(e: MouseEvent){
    //     if (this.mouseDown) this.resizeGrid();
    // }

    /*@HostListener('window:keydown', ['$event']) onKeyDown(e: KeyboardEvent){
        this.handleKeys(e, true);
    }

    @HostListener('window:keyup', ['$event']) onKeyUp(e: KeyboardEvent){
        this.handleKeys(e, false);
    }*/

    @Input() param: string;
    @Input() type: number;
    @Input() separator: string[];
    @Input() isTranslate?: number;
    @Input() innerFiltering?: number;
    // TODO add module name for stocks, item properties, supplySchedules
    @Input() module?: string;
    @Input() position: number;
    @Input() GUID: string;
    @Input() popper?: { position: string } ;
    @Input() showButtons?: boolean;
    @Input() getDataFunc?: (param: string, filter: StocksFilter) => Observable<CodeName[]>;
    @Input() filterDataFunc?: (data: CodeName[]) => CodeName[];
    @Input() validationFunction?: (r, c, v) => Slick.ValidateResults;
    @Input() getFurtherData?: () => CodeName[];
    @Input() validationData?: string[];
    @Input() excludeResWarn?: boolean;
    @Input() readonly exchangeService?: SCDataExchangeService;
    @Input() placeholder?: string;
    @Input() alwaysShowGrid?: boolean;
    @Input() inWrpClasses?: string[];
    // @Input() dimensions?: { width: number, height: number };

    @Output() validationResults: EventEmitter<boolean>;

    @ViewChild('grid')
    private grid: SlickGridComponent;

    @ViewChild('inputDataEl')
    private inputDataEl: ElementRef;

    @ViewChild('inputSearchEl')
    private inputSearchEl: ElementRef;

    @ViewChild('gridWrpEl')
    private gridWrpEl: ElementRef;

    @ViewChild('showSearchEl')
    private showSearchEl: ElementRef;

    @ViewChild('showSearchEl2')
    private showSearchEl2: ElementRef;

    @ViewChild('clearSearchFilterEl')
    private clearSearchFilterEl: ElementRef;

    @ViewChild('showAllDataEl')
    private showAllDataEl: ElementRef;

    @ViewChild('showAllDataEl2')
    private showAllDataEl2: ElementRef;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    public readonly gridView: Slick.Data.DataView<CodeName>;
    public columns: Slick.Column<CodeName>[];
    public readonly options: Slick.GridOptions<CodeName>;
    public readonly selectionModel: Slick.RowSelectionModel<CodeName, Slick.Range[]>;
    private slickGridProp: SlickGridColumns[];
    private data: CodeName[];
    private filteredData: CodeName[];
    private filter: StocksFilter;
    private filterJson: StocksFilter;
    private filtersState: StocksFiltersState;
    private hasData: boolean;
    public __inputData: string;
    public searchData: string;
    public _showGrid: boolean;
    public _showSearch: boolean;
    public _loading: boolean;
    public mouseDown: boolean;
    private timeOut: any;
    private checkBoxHeader: any;
    private lazySearch: boolean;
    private allItemsQuantity: number;
    private selectedQuantity: number;
    public cellCssStyles: { [key: string]: Slick.CellCssStylesHash };
    private codesToRemove: string [];
    private subscription: ISubscription;
    private subscriptionState: ISubscription;
    private subscriptionFill: ISubscription;
    private subscriptionFillAdditionalData: ISubscription;
    private subscriptionScroll: ISubscription;
    private subscriptionSelectedFilter: ISubscription;
    private subscriptionClearSelectedFilter: ISubscription;
    private subscriptionLoadData: ISubscription;
    private subscriptionSetFocus: ISubscription;
    private subscriptionHideGrid: ISubscription;
    private subscriptionBlockFilter: ISubscription;
    private subscriptionClearFilter: ISubscription;
    private subscriptionMouseMove: ISubscription;
    public focusActive: boolean;
    private focusSearchActive: boolean;
    private ctrlPressed: boolean;
    private plusPressed: boolean;
    public loadDataError: boolean;
    public develop: boolean;
    public emptyData: boolean;
    public wrpClass: any;
    public gridTop: number;
    public messageTop: number;
    public messageShowScroll: boolean;
    public height: number;
    //private selectedFilter: SelectedFilter;
    // private selectedFilters: any;
    public selected: boolean;
    private inGrid: boolean;
    public blockFilter: boolean;
    private prevInputData: string;
    private prevInputDataUpdate: boolean;
    public notValidatedData: ValidateData[];
    public notValidatedDataTop: number;
    public notValidatedDataRight: number;
    public notValidatedDataShowScroll: boolean;
    public _showGridByScroll: boolean;
    public $modalBody: any;
    public $filtersWrp: any;
    public hideMessageTime: number;
    public viewInit: boolean;
    private slickScrollWidth: number;
    public gridHeight: number;
    public gridWidth: number;
    private helper: StocksHelper;
    private popperObj: Popper;
    public valControl: number;
    public propsName: ModuleTableName
    // public dimensions: any;

    ngOnInit(){
        this.placeholder = this.placeholder ? this.placeholder : 'Search';
        this.separator = this.separator ? this.separator : [';'];

        this.propsName = this.module ? new ModuleTableName(this.module, this.param + 'Filter') : null;

        this.applyDimensions();

        this.innerFiltering = this.innerFiltering ? 1 : 0;

        this.columns = this.removeColumn(this.columns);
        //# update filter when some changes occur in other filter
        this.subscription = this.filterService.stocksFilterCurrent.subscribe((res: StocksFilterGUID[]) => {
            this.helper.tryCatch(() => {
                let found: StocksFilterGUID = this.helper.getGUIDObj(res, this.GUID);
                if (found && !this.helper.compareSimpleObj(this.filter, found.stocksFilter)){
                    this.filter = found.stocksFilter;
                }
            })
        });

        //# update filterState when changes occur in other filter
        this.subscriptionState = this.filterService.stocksFiltersStateCurrent.subscribe((res: StocksFiltersStateGUID[]) => {
            this.helper.tryCatch(() => {
                let found: StocksFiltersStateGUID = this.helper.getGUIDObj(res, this.GUID);
                if (found && !this.helper.compareSimpleObj(this.filtersState, found.stocksFiltersState)){
                    this.filtersState = found.stocksFiltersState
                }
            })
        });

        //# fill filter with previous applied filter, filled once when initialise
        this.subscriptionFill = this.filterService.fillFilterCurrent.subscribe((res: { GUID: string, fillFilter: boolean }) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.fillFilter = res.fillFilter : null)
        );

        //# fill filter with additional data when changes occur in other filter
        this.subscriptionFillAdditionalData = this.filterService.fillFilterAdditionalDataCurrent.subscribe((res: { GUID: string, additionalDataObj: any }) =>
            this.helper.tryCatch(() => res && res.additionalDataObj && res.GUID === this.GUID ? this.fillFilterAdditionalData = res.additionalDataObj : null)
        );

        //# update when scroll changed in main filter
        this.subscriptionScroll = this.filterService.filtersScrollCurrent.subscribe(res =>
            this.helper.tryCatch(() => this.scrollPosition = res)
        );

        //#
        // this.subscriptionSelectedFilter = this.filterService.selectedFiltersCurrent.subscribe((res: SelectedFilterGUID) => {
        //     this.helper.tryCatch(() => {
        //         if (res && res.GUID === this.GUID ){
        //             this.selectedFilters = res.selectedFilters
        //         }
        //     })
        // });

        this.subscriptionClearSelectedFilter = this.filterService.clearSelectedFilterCurrent.subscribe((res: ClearSelectedGUID) => {
            this.helper.tryCatch(() => {
                if (res && res.GUID === this.GUID){
                    this.clearSelectedFilter = res.clearSelected
                }
            })
        });

        this.subscriptionClearFilter = this.filterService.clearFilterCurrent.subscribe((res: { GUID: string, command: string }) => {
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.clearFilter = res.command : null)

        });

        this.subscriptionLoadData = this.filterService.loadDataFilterCurrent.subscribe((res: { GUID: string, param: string }) => {
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.loadData = res.param : null)

        });

        this.subscriptionSetFocus = this.filterService.goToNextFilterCurrent.subscribe((res: { GUID: string, param: string }) => {
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.hideGrid = res.param : null)
        });

        this.subscriptionHideGrid = this.filterService.hideFilterGridCurrent.subscribe((res: { GUID: string, param: string }) => {
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.hideGrid = res.param : null)
        });

        this.subscriptionBlockFilter = this.filterService.blockFilterCurrent.subscribe((res: BlockFilterGUID) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.block = res.blockFilter : null)
        );

        this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(e => {
            // console.log(this.commonService.count, e, 'subscriptionMouseMove')
            this.helper.tryCatch(() => {
                if (e && this.mouseDown) this.resizeGrid()
            })
        });

        this.wrpClass = this.generateWrpClass();
    }

    ngOnDestroy(){
        this.subscription.unsubscribe();
        this.subscriptionState.unsubscribe();
        this.subscriptionFill.unsubscribe();
        this.subscriptionFillAdditionalData.unsubscribe();
        this.subscriptionScroll.unsubscribe();
        // this.subscriptionSelectedFilter.unsubscribe();
        this.subscriptionClearSelectedFilter.unsubscribe();
        this.subscriptionClearFilter.unsubscribe();
        this.subscriptionLoadData.unsubscribe();
        this.subscriptionSetFocus.unsubscribe();
        this.subscriptionHideGrid.unsubscribe();
        this.subscriptionBlockFilter.unsubscribe();
    }

    ngAfterViewInit(){

        let timeout = setTimeout(() => {
            clearTimeout(timeout);
            timeout = null;
            this.initHtmlDimensions();
            //this.setMessageTop();
        }, 0);
        //console.log($(this.mainWrapper.nativeElement.parentElement).prevAll());
    }

    private readonly initHtmlDimensions = (): void => {
        if (this.inWrpClasses && this.inWrpClasses.length === 2){
            this.$modalBody = $(`.${this.inWrpClasses[0]}`);
            this.$filtersWrp = $(`.${this.inWrpClasses[1]}`);
        } else {
            this.$modalBody = $('.modal-body');
            this.$filtersWrp = $('.filters-wrp');
        }

        this.setNotValidateDataTop();

        this.viewInit = true;
        this.popper
            ? this.popperObj
                ? this.popperObj.setOptions({ placement: this.popper.position })
                : this.popperObj = this.helper.popperAdd(this.inputSearchEl, this.gridWrpEl, document.body, this.popper.position, ['bottom', 'top'], false)
            : null;
    }

    /**
     * set work with metadata
     * @param old_metadata_provider - function of old metadata provider, need for old functional work
     */
    private metadata = function (old_metadata_provider){

        return function (row){
            let item: CodeName = this.getItem(row);
            let ret = (old_metadata_provider(row) || {});

            if (item.disabled){
                ret.cssClasses = (ret.cssClasses || '');
                ret.cssClasses += ' disabled';
            }
            return ret;
        }
    };

    public set fillFilter(fill: boolean){
        if (fill && this.filter[this.param]){
            this.fillFilterFunc().then();

        }
    }

    /**
     * fill filter with setted data
     */
    public fillFilterFunc = async (): Promise<void> => {

        if (this.develop) console.log(this.filter[this.param]);
        if (this.develop) console.log(this.param);
        if (this.type === FilterType.CodeName){
            this.prevInputData = this._inputData = this.getStringFromArr(this.filter[this.param]);
        } else{
            // console.log(this.filter[this.param + 'name']);
            // this.filter[this.param + 'name'] = await this.translateData(this.filter[this.param + 'name']);
            this.prevInputData = this._inputData = this.getStringFromArr(this.filter[this.param + 'name']);
        }
        // console.log(this.filter[this.param], this.filter[this.param].length, 'fillFilterFunc');


        if (this.filter[this.param]){
            this.selected = !!this.filter[this.param].length;
        }


    }

    public set fillFilterAdditionalData(data: any){
        if (data && data[this.param]){
            this.helper.wait( () => this.fillFilterAdditionalDataFunc(data).then(), 5);
        }

    }

    private fillFilterAdditionalDataFunc = async (data: any): Promise<void> => {

        if (this.develop) console.log(data[this.param], 'fillFilterAdditionalData', this.param);

        if (this.type === FilterType.CodeName){
            this._inputData += this.separator[0] + this.getStringFromArr(data[this.param].filterData.map(item => item.code));

        } else{
            let newData = data[this.param].filterData.map(item => new CodeName(item.id, false, item.code, item.name));

            // newData = await this.helper.translateData(newData, this.commonData.translateService, 'name', 'name');
            this._inputData += this.separator[0] + this.getStringFromArr(newData.map(item => item.name));
        }

        /*if (this.type === 1){
            console.log(this.getStringFromArr(data[this.param].filterData.map(item => item.code)), 'fillFilterAdditionalData');
        } else{
            console.log(this.getStringFromArr(data[this.param].filterData.map(item => item.name)), 'fillFilterAdditionalData');
        }

        console.log(this._inputData, 'fillFilterAdditionalData');*/

        this.prevInputData = this._inputData = this.onlyUniqueItems(this._inputData);
        await this.getNotValidateDataAdditionalData(data[this.param].filterData);

        if (this.viewInit){
            this.setNotValidateDataTop();
        }

        this.selected = data[this.param].filterData.length > 0;

    }

    public set loadData(param: string){
        if (this.param === param){
            this.getData();
        }
    }

    public set loading(value: boolean){
        if (this._loading !== value){
            this._loading = value;
            this.filterService.setBlockFilter({GUID: this.GUID, blockFilter: new BlockFilter(this.param, value)});
        }
    }

    public get loading(){
        return this._loading;
    }

    public set block(value: BlockFilter){
        if (value && value.param !== this.param){
            this.blockFilter = value.block;
        }
    }

    public set showGrid(value: boolean){
        // console.log(value, this.inputData, this.prevInputData, 'showGrid')
        if (!value){
            if (this.inputData !== this.prevInputData){
                this.getAdditionalData();
            }
        }
        if (this._showGrid !== value){
            this._showGrid = value;
            this.showGridByScroll = value;
            this.inGrid = false;

            if (value){
                this.filterService.setHideFilterGrid({GUID: this.GUID, param: this.param});
                this.calculateHeightForGrid();
                this.setGridTop();
                this.columnWidth();
            } else{

                this.prevInputData = this.inputData;
            }
        }
    }

    public get showGrid(){
        return this._showGrid;
    }

    public set showGridByScroll(value: boolean){
        if (this._showGridByScroll !== value){
            this._showGridByScroll = value;
        }

        this.showMessagesAlways();
    }

    public get showGridByScroll(){
        return this._showGridByScroll;
    }

    public set hideGrid(param: string){
        if (this.param !== param){
            this.showGrid = false;
        }
    }

    public set setFocus(param: string){
        if (this.param === param){
            setTimeout(() => {
                this.inputDataEl.nativeElement.focus();
            }, 0)
        }
    }

    private set scrollPosition(value: number){
        if (value !== null){
            this.setGridTop();
            if (this.loading || this.loadDataError || this.emptyData){
                this.setMessageTop();
            }
            this.setNotValidateDataTop();
        }
    };

    private set clearSelectedFilter(clearFilter: ClearSelected){

        if (clearFilter && this.param === clearFilter.name){

            if (clearFilter.clearAll){
                this.clearDataFilter();
            } else{
                // console.log(this.data, 'clearSelectedFilter');
                if (this.data && this.data.length){
                    this.data.forEach(item => {
                        // console.log(item.code, clearFilter.data.code, 'clearSelectedFilter');
                        if (item.code === clearFilter.data.code){

                            this.selectRow(clearFilter.data);
                            this.gridView.setItems([]);
                            this.gridView.setItems(this.filteredData);
                            this.grid.render();
                        }
                    })
                } else{
                    this.removeSelected([clearFilter.data.code], false);
                }

            }
            this.updateDataSubscription(this.inputData);
        }
    }

    private set clearFilter(command: string){
        if (command === 'clear'){
            this.clearDataFilter(false);
            this.initialise();
        }
    }

    public set inputData(data: string){
        if (this._inputData !== data){

            this._inputData = data;

            if (this.develop) console.log(data, 'inputData', this.param);
            if (!data){
                //console.log(data, 'inputData', this.param);
                this.updateDataSubscription(data);
            }
        }
    }

    public get inputData(){
        return this._inputData
    }

    public set _inputData(data: string){
        if (this.__inputData !== data){
            // console.log(data, '_inputData')
            this.__inputData = data;
            this.helper.wait(() => {
                this.valControl = this.valControl === BTControl.show ? BTControl.showAgain : BTControl.show;
                this.changeDetector.detectChanges();
            })


        }
    }

    public get _inputData(){
        return this.__inputData
    }

    private updateStocksFilter = (data: string): void => {
        if (data){
            let selected: CodeName[] = this.data.filter(item => item.selected);
            /*if (selected.length > 0){
                this.filter[this.param] = this.type === 4 ? selected.map(item => Number(item.code)) : selected.map(item => item.code);
                if (this.type === 2 || this.type === 4){
                    this.filter[this.param + 'name'] = selected.map(item => item.name);
                }
            } else{
                this.filter[this.param] = null;
                if (this.type === 2 || this.type === 4){
                    this.filter[this.param + 'name'] = null;
                }
            }*/
            // this.filter[this.param] = this.type === 4 ? this.getArrFromString(data).map(item => Number(item)) : this.getArrFromString(data);
            switch (this.type){
                case FilterType.CodeName:
                    this.filter[this.param] = this.getArrFromString(data);
                    break;
                case FilterType.Name:
                    this.filter[this.param] = selected.map(item => item.code);
                    break;
                case FilterType.SmallName:
                    this.filter[this.param] = selected.map(item => Number(item.code));
                    break;
            }

            if (this.type === FilterType.Name || this.type === FilterType.SmallName){
                this.filter[this.param + 'name'] = this.getArrFromString(data);
            }
            if (this.develop) console.log(this.filter[this.param], 'updateStocksFilter');
            if (this.develop && (this.type === FilterType.Name || this.type === FilterType.SmallName)) console.log(this.filter[this.param + 'name'], 'updateStocksFilter');
        } else{
            this.filter[this.param] = null;
            if (this.type === FilterType.Name || this.type === FilterType.SmallName){
                this.filter[this.param + 'name'] = null;
            }
        }
    };

    private updateSelectedFilter = (): void => {

        let selected = this.data.filter(item => item.selected);
        let selectedFilter: SelectedFilter = new SelectedFilter(this.param, this.type, this.position);
        if (selected.length > 0){
            //let selectedFilter: SelectedFilter = new SelectedFilter(this.param, this.type, this.position);
            selectedFilter.data = selected;
            selectedFilter.selectedQuantity = selectedFilter.data.length;
            selectedFilter.allItemsQuantity = this.data.length;

            if (this.type === FilterType.CodeName){
                selectedFilter.dataString = this.getStringFromArr(selectedFilter.data.map(item => item.code));
            } else{
                selectedFilter.dataString = this.getStringFromArr(selectedFilter.data.map(item => item.name));
            }

        } else if (this.data && this.data.length === 0){
            let selectedFilters = this.filterService.getSelectedStorageFilters(this.GUID);
            if (selectedFilters){
                let selectedFilterOld = selectedFilters.selectedFilters.find(sf => sf.name === this.param);

                selectedFilter.dataString = this.inputData;
                let dataArr = this.getArrFromString(this.inputData)

                selectedFilter.selectedQuantity = dataArr.length;
                selectedFilter.data = [];
                if (selectedFilterOld){
                    selectedFilter.allItemsQuantity = selectedFilterOld.allItemsQuantity;
                    let dataCodeNameObj = this.helper.arrToObj(selectedFilterOld.data, 'code');
                    dataArr.forEach(item => {
                        if (dataCodeNameObj[item]){
                            selectedFilter.data.push(dataCodeNameObj[item]);
                        }
                    })
                }
            }
        }

        this.filterService.setSelectedFilters({GUID: this.GUID, selectedFilters: [selectedFilter]});
        // if (this.develop) console.log(this.selectedFilters, 'updateSelectedFilter')
    };

    private needUpdateStocksFilter = (): boolean => {
        if (this.inputData){
            let arr = this.getArrFromString(this.inputData);
            //let arr = this.data.filter(item => item.selected).map(item => item.code);
            // console.log(this.sortArr(arr), 'needUpdateStocksFilter data');
            // console.log(this.sortArr(this.filter[this.param]), 'needUpdateStocksFilter filter');

            //return !this.compareArr(this.sortArr(arr), this.sortArr(this.filter[this.param]))
            return this.type === FilterType.CodeName
                ? !this.compareArr(this.sortArr(arr), this.sortArr(this.filter[this.param]))
                : !this.compareArr(this.sortArr(arr), this.sortArr(this.filter[this.param + 'name']));
        } else{
            return this.type === FilterType.CodeName ? this.filter[this.param] !== null : this.filter[this.param + 'name'] !== null;
        }
    };

    private updateDataSubscription = (data: string): void => {
        // if (this.needUpdateStocksFilter()) {
        this.updateStocksFilter(data);
        this.updateSelectedFilter();
        this.filterService.setFilter({GUID: this.GUID, stocksFilter: this.filter});
        this.filterService.updateFiltersState({GUID: this.GUID, prop: this.param});
        // console.log(this.filtersState, 'updateDataSubscription', this.param)
        if (this.develop) console.log(this.filtersState, 'updateDataSubscription', this.param);
        // }


    };

    public onBlur = (e: any): void => {
        this.helper.wait(() => this.focusActive = false, 200);

        if (this.hasData){
            this.addSelected();
            this.filterSearch();


            //this.syncSelected();
            //this.updateStocksFilter(this.inputData);
            //this.setSelectedQuantity();

        }
        if (this.prevInputData !== this.inputData){
            this.getAdditionalData();
        }

        this.prevInputData = this.inputData;
        this.emptyData = false;
        this.loadDataError = false;
    };

    public onSearchBlur = (e: any): void => {
        let timeOut = setTimeout(() => {
            //this.inputDataEl.nativeElement.focus();
            clearTimeout(timeOut);
            timeOut = null;
        }, 50);

        this.emptyData = false;
        this.loadDataError = false;

        //this.focusSearchActive = false;
        //this.inputDataEl.nativeElement.focus();
    };

    public onFocus = (): void => {
        if (this.develop) console.log('onFocus', this.param);
        this.type === FilterType.SmallName ? this.getData(true) : this.getData();
        this.focusActive = true;

        //if (!this._showSearch && this.hasData && this.type !== 4 && !this.inputData) this.setFocusWithTimeout();
        //this._showSearch = true;
    };

    public onSearchFocus = (e: any): void => {
        // console.log('onSearchFocus');
        this.getData(true);
        this.focusSearchActive = true;
    };

    private generateWrpClass = (): any => {
        let classes: any = {wrp: true};
        switch (this.type){
            case 1:
                classes['type-1'] = true;
                break;
            case 2:
                classes['type-2'] = true;
                break;
            case 4:
                classes['type-4'] = true;
                break;
        }
        return classes;
    };

    public getData = async (showResult?: boolean): Promise<void> => {
        if (this.develop) console.log(this.hasData, this.filtersState[this.param], 'getData', this.param);
        // console.log(this.filter, 'getData Filter', this.param);
        // console.log(this.filtersState, 'getData 2 this.filtersState', this.param);
        if (!this.hasData || !this.filtersState[this.param]){
            if (this.develop) console.log('getData 2');
            this.loadDataError = false;
            this.loading = true;
            this.setMessageTop();
            this.setSlickGridProps();
            let getDataFunc = this.getDataFunc ? this.getDataFunc : this.filterService.GetDataForCodeNameFilter;

            const noData = (): void => {
                this.hasData = true;
                this.emptyData = true;
                this.hideMessage('emptyData');
                console.error('Error empty data');
            }

            let data = await getDataFunc(this.param, this.filter).toPromise();
            // getDataFunc(this.param, this.filter).subscribe(async data => {
                if (!data){
                    this.loadDataError = true;
                    this.hideMessage('loadDataError');
                    this.emptyData = false;
                    this.loading = false;
                    console.error('Error loading data');
                    return;
                } else if (data && data.length > 0){
                    //this.data = data;
                    this.hasData = true;
                    this.emptyData = false;

                } else if (data && data.length === 0){
                    noData()
                } else{
                    console.error('Error loading data');
                    this.loadDataError = true;
                    this.emptyData = false;
                    this.hasData = false;
                    this.hideMessage('loadDataError');
                }

                this.setMessageTop();
                // console.warn(data, 'get data')

                if (!data){
                    return;
                }

                // console.log(data.map(i => i), this.param);


                data = data.filter(item => item.code);


                if (this.filterDataFunc){
                    data = this.filterDataFunc(data);
                    if (data && data.length === 0){
                        noData()
                    }
                }

                // data.forEach((item: CodeName) => item.name === null ? item.name = '' : item.name);
                data.forEach(item => {
                    item.code = typeof item.code === 'number' ? (item.code as number).toString() : item.code.trim();
                    item.name = item.name === null ? '' : item.name.trim();
                });

                if (this.isTranslate === 1) data = await this.helper.translateData(data, this.commonData.translateService, 'name', 'name');

                this.data = this.data.length === 0 ? data : this.refreshData(data);

                // console.log(this.filtersState, 'this.filtersState')
                // console.log(this.param, 'this.param')

                this.filtersState[this.param] = true;
                this.filterService.setFiltersState({GUID: this.GUID, stocksFiltersState: this.filtersState});

                this.loading = false;

                if (this.loadDataError) return;


                // this.filteredData = this.data;
                if (this.develop) console.log(this.type, 'getData 2 type');


                //this.syncSelected();
                this.addSelected();
                // this.filteredData.sort(function (a: any, b: any){
                //     return b.selected - a.selected;
                // });
                //this.setSelectedQuantity();
                // this.gridView.setItems([]);
                // this.gridView.setItems(this.filteredData);
                //this.checkAllSelect();
                this.filterSearch();
                this.setSelectedRows();
                this.resizeGrid();

                if (this.lazySearch){
                    // this.type === 4 ? this.showGrid = true : this.filterSearch();
                    this.helper.wait(() => {
                        this.type === FilterType.SmallName ? null : this.filterSearch();
                        this.lazySearch = false;
                    }, 100)
                }

                if (showResult && this.data.length){
                    this.showGrid = true;
                    this._showSearch = true;
                    //this.setGridTop();
                }
                //this.setFocusWithTimeout();

                this.allItemsQuantity = this.data.length;
            // })
        } else{

            if (showResult && this.data.length){
                this.showGrid = true;
                this._showSearch = true;
                this.grid.invalidate();
                //this.setGridTop();
            } else if (this.data.length === 0){
                this.emptyData = true;
                this.hideMessage('emptyData')
            }
            //this.showGrid = true;
        }
    };

    private getAdditionalData = (): void => {
        // console.log(this.param, 'getAdditionalData start');
        let param = this.helper.needGetAdditionalData(this.filter) ? this.param : 'cancelUpdate';
        this.filterService.setGetAdditionalData({GUID: this.GUID, param: param, filter: this.filter});
    };

    private refreshData = (data: CodeName[]): CodeName[] => {
        let newDataObj, oldDataObj, comparedObj;
        newDataObj = this.arrToObj(data, this.type);
        oldDataObj = this.arrToObj(this.data, this.type);
        comparedObj = this.compareSelected(newDataObj, oldDataObj);
        data = this.objToArr(comparedObj);
        return data;
    };

    private arrToObj = (data: any[], type: number, trim?: boolean): any => {
        let obj: any = {};
        const getFormattedProp = (prop: any): string => {
            return trim ? prop.toLowerCase().trim() : prop.toLowerCase();
        }
        data.forEach(item => {
            type === FilterType.CodeName
                ? obj[getFormattedProp(item.code)] = item
                : obj[getFormattedProp(item.name)] = item;
        });
        return obj;
    };

    private stringArrToObj = (data: string[], type: number, trim?: boolean): any => {
        let obj: any = {};
        data.forEach(item => {
            obj[trim ? item.toLowerCase().trim() : item.toLowerCase()] = item;
        });
        return obj;
    };


    private removeByObj = (data: string[], needRemove: string[]): string[] => {
        let dataObj: any = {},
            arr: string[] = [];
        data.forEach((item, i) => {
            if (!dataObj[item.toLowerCase()]){
                dataObj[item.toLowerCase()] = {data: item, index: i};
            }

        });

        needRemove.forEach(item => {
            delete dataObj[item.toLowerCase()];
        });

        for (let prop in dataObj){
            arr[dataObj[prop].index] = dataObj[prop].data;
        }
        arr = arr.filter(item => item);
        return arr;
    };

    private objToArr = (data: any): any[] => {
        let arr: any[] = [];
        for (let prop in data){
            arr.push(data[prop]);
        }
        return arr;
    };

    private compareSelected = (newData: any, oldData: any): any => {
        for (let prop in newData){
            if (oldData[prop] && oldData[prop].selected) newData[prop].selected = true;
        }
        return newData;
    };

    private compareDataFromString = (stringData: any, data: any): any => {
        for (let prop in stringData){
            if (data[prop]) data[prop].selected = true;
        }
        return data;
    };

    private validateData = (stringData: any, data: any): ValidateData[] => {
        let noData: ValidateData[] = [];
        for (let prop in stringData){
            if (!data[prop]) noData.push(new ValidateData(stringData[prop]));
        }
        return noData;
    };

    private validateAdditionalData = (data: string[], realSelected: string[]): ValidateData[] => {
        //let res = data.filter(item => !realSelected.some(inItem => item.toLowerCase() === inItem.toLowerCase()));
        let res = this.removeByObj(data, realSelected);
        return res.map(r => new ValidateData(r));
    };

    public showGridWithData = (): void => {
        // console.log('showGridWithData')
        if (!this.loading){
            if (!this.hasData){
                // this.lazySearch = true;
            }

            if (this.develop && !this.loading) console.log('showGridWithData', '2');
            if (!this.showGrid && this.type !== 4){
                this.inputSearchEl.nativeElement.focus();
            } else if (!this.showGrid && this.type === FilterType.SmallName){
                this.inputDataEl.nativeElement.focus();
            } else if (this.showGrid){
                this._showSearch = this.showGrid = !this.showGrid;
                this.popper ? this.popperObj.update() : this.gridTop = 0;
            }


            /*this._showSearch = this.showGrid = !this.showGrid;
            if (this.showGrid && this.type !== 4) {
               this.inputSearchEl.nativeElement.focus();
            } else if (this.showGrid && this.type === 4) {
                this.getData();
            } else if (!this.showGrid) {
                this.gridTop = 0;
            }*/
        }


        //this.showGrid ? this.setGridTop() : this.gridTop = 0;

    };

    /*public showSearch = (): void =>{
        if (this._showSearch || this.showGrid){
            this._showSearch = false;
            this.showGrid = false;
        } else{
            this._showSearch = true;
            this.showGrid = true;
            if (!this.loading) this.getData(true);
        }

        if (!this.loading){
            if (this._showSearch) this.setFocusWithTimeout();
            this.setSelectedRows();
        }
    };*/

    private setFocusWithTimeout = (): void => {
        if (this.develop) console.log('setFocusWithTimeout');
        if (this.type !== 4){
            let timeOut = setTimeout(() => {
                this.inputSearchEl.nativeElement.focus();
                clearTimeout(timeOut);
                timeOut = null;
            }, 50);
        }
    };

    private hideGridOnClick = (e: MouseEvent): void => {

        if (this.loadDataError) this.loadDataError = false;

        if (this.showGrid || this._showSearch){

            if (this.develop) console.log(this.showGrid, this._showSearch, 'hideGridOnClick', this.param);

            if (!e.target) return;

            let target = e.target;

            if (this.showSearchEl && this.showSearchEl.nativeElement.isSameNode(target) ||
                //this.showSearchEl2 && this.showSearchEl2.nativeElement.isSameNode(parentElement) ||
                this.clearSearchFilterEl && this.clearSearchFilterEl.nativeElement.isSameNode(target) ||
                this.showAllDataEl && this.showAllDataEl.nativeElement.isSameNode(target) ||
                this.showAllDataEl2 && this.showAllDataEl2.nativeElement.isSameNode(target) ||
                this.checkParent(this.showSearchEl, target, true) ||
                this.checkParent(this.clearSearchFilterEl, target, true) ||
                this.checkParent(this.showAllDataEl, target, true) ||
                this.checkParent(this.showAllDataEl2, target, true)
            ) return;

            let otherFilter: boolean = false;
            if (this.showSearchEl && this.showSearchEl.nativeElement === target ||
                //this.showSearchEl2 && this.showSearchEl2.nativeElement.isSameNode(parentElement) ||
                this.clearSearchFilterEl && this.clearSearchFilterEl.nativeElement === target ||
                this.showAllDataEl && this.showAllDataEl.nativeElement === target ||
                this.showAllDataEl2 && this.showAllDataEl2.nativeElement === target ||
                this.checkParent(this.showSearchEl, target, false) ||
                this.checkParent(this.clearSearchFilterEl, target, false) ||
                this.checkParent(this.showAllDataEl, target, false) ||
                this.checkParent(this.showAllDataEl2, target, false)
            ) otherFilter = true;

            let hideGrid: boolean = true;
            if (this.develop) console.log('hideGridOnClick', this.param);
            if (this.inputDataEl.nativeElement.isSameNode(target) || this.inputSearchEl && this.inputSearchEl.nativeElement.isSameNode(target)){
                hideGrid = false;
            }

            if (this.develop) console.log(hideGrid, 'hideGrid 1');

            let parentElement = target;

            if (hideGrid){
                while (parentElement){
                    if (this.gridWrpEl && this.gridWrpEl.nativeElement.isSameNode(parentElement)) hideGrid = false;
                    if (this.gridWrpEl && this.gridWrpEl.nativeElement === parentElement) otherFilter = true;
                    parentElement = this.renderer.parentNode(parentElement);
                }
            }

            if (this.develop) console.log(hideGrid, 'hideGrid 2');

            if (this.develop) console.log(this.inputData, 'this.inputData  hideGrid 3');

            hideGrid && this.hideGridFunc(otherFilter)
        }
    };

    public readonly hideGridFunc = (otherFilter?: boolean): void => {
        this.addSelected();
        otherFilter && this.inputDataEl.nativeElement.focus();
        this.showGrid = false;
        this.popper ? this.popperObj.update() : this.gridTop = 0;
        this._showSearch = false;
        this.loadDataError = false;
        this.clearSearchFilter();
    }

    /**
     * add SKU to schedule for schedules
     */

    //TODO do dependensy injection
    public addSKUToSchedule = (): void => {
        let filter: StocksFilterGUID = this.filterService.getFilter(this.GUID),
            filterClone: StocksFilter = this.helper.deepCopy(filter.stocksFilter),
            clearFilter = new ClearSelected('skus', true),
            skus = filter.stocksFilter.skus.map(skus => skus);
        filter.stocksFilter.skus.length = 0;
        this.filterService.setFilter(filter);
        this.helper.remFromArrArrSimple(filterClone.skus, this.notValidatedData.map(nvd => nvd.code))
        // console.log(filterClone.skus, this.notValidatedData.map(nvd => nvd.code), 'addSKUToSchedule')
        this.filterService.setClearSelectedFilter({ GUID: this.GUID, clearSelected: clearFilter });
        this.filtersState.skus = false;
        this.filterService.setFiltersState(new StocksFiltersStateGUID(this.GUID, this.filtersState));
        this.exchangeService.setGetControlItemData({GUID: this.GUID, param: 'skus', filter: filterClone});
        this.hideGridFunc();
        //console.log(this.data, skus, 'addSKUToSchedule')
        this.helper.remFromArrArr(this.data, 'code', skus);
        this.filterSearch();
    }

    public addSKUToScheduleSupplierCard = (): void => {

        let filter: StocksFilterGUID = this.filterService.getFilter(this.GUID),
            filterClone: StocksFilter = this.helper.deepCopy(filter.stocksFilter);

        if (this.helper.stocksFilterEmpty(filter.stocksFilter)){
            return;
        }

        // console.log(this.helper.stocksFilterEmpty(filter.stocksFilter))
        // console.log(new StocksFilter(), 'new')

        filter.stocksFilter = new StocksFilter();
        filter.stocksFilter.suppliers = filterClone.suppliers;
        this.filterService.setFilter(filter);
        if (filterClone.skus){
            this.helper.remFromArrArrSimple(filterClone.skus, this.notValidatedData.map(nvd => nvd.code))
        }

        // console.log(filterClone.skus, this.notValidatedData.map(nvd => nvd.code), 'addSKUToScheduleSupplierCard+')
        // this.filterService.setClearSelectedFilter({ GUID: this.GUID, clearSelected: clearFilter });

        // this.filtersState = new StocksFiltersState();
        // this.filterService.setFiltersState(new StocksFiltersStateGUID(this.GUID, this.filtersState));
        this.filterService.setFiltersState({GUID: this.GUID, stocksFiltersState: new StocksFiltersState()});
        this.filterService.setClearFilter({GUID: this.GUID, command: 'clear'});

        this.exchangeService.setGetControlItemData({GUID: this.GUID, param: 'skus', filter: filterClone});
        this.hideGridFunc();
        // console.log(this.data, skus, 'addSKUToSchedule')
        // this.helper.remFromArrArr(this.data, 'code', skus);
        this.filterSearch();
    }

    private checkParent = (el: ElementRef, target: any, same: boolean): boolean => {
        if (el){
            let parent = target.parentElement;
            return same ? parent.isSameNode(el.nativeElement) : parent === el.nativeElement;
        }
        return false;
    };

    public slickGridHeaders = (args: any): void => {
        if (args.data.column.id === 'selected'){
            this.checkBoxHeader = args.data.node.querySelector('input');
            this.renderer.listen(this.checkBoxHeader, 'change', e => this.selectAll(e.target.checked));
        }
    };

    private onlyUnique = (value, index, self): boolean => {
        return value ? self.indexOf(value) === index : false;
    };

    private syncSelected = (): void => {

        this.data.forEach(item => item.selected = false);
        let selected = this.getArrFromString(this.inputData),
            stringObj = this.stringArrToObj(selected, this.type),
            dataObj = this.arrToObj(this.data, this.type);
        dataObj = this.compareDataFromString(stringObj, dataObj);

        let tempData = this.objToArr(dataObj),
        selectedData = tempData.filter(td => td.selected),
        noSelectData = tempData.filter(td => !td.selected)

        if (this.propsName){
            this.helper.sortDataFromLSInGrid(this.generateNameForDimensions(true), selectedData);
            this.helper.sortDataFromLSInGrid(this.generateNameForDimensions(true), noSelectData);
            let sort = this.helper.getDataFromLS(this.generateNameForDimensions(true))
            if (sort){
                this.grid.setSortColumn(sort.columnId, sort.sortAsc);
            }
        }

        this.data = selectedData.concat(noSelectData);
        this.helper.wait(this.grid.invalidate, 100)

        if (this.develop) console.log(selected, 'syncSelected', 1);
        this.updateDataSubscription(this.inputData);

        if (this.develop) console.log(this.data.filter(item => item.selected), 'syncSelected 3')
    };

    public addSelected = (): void => {
        // if (this.inputData){
        if (this.develop) console.log('addSelected');

        this.inputData = this.onlyUniqueItems(this.inputData);

        this.syncSelected();

        // this.checkAllSelect();
        // this.setSelectedRows();


        //this.inputData ? this.inputData += ', ' : '';

        this.setSelectedQuantity();

        // } else{
        //     this.clearDataFilter(false);
        //     this.syncSelected();
        // }
        this.getNotValidateData();
        this.setNotValidateDataTop();
        this.setDisabled();
        //this.showGrid = false;
        //this._showSearch = false;
    };

    private setDisabled = (): void => {
        if (!this.validationData){
            return;
        }

        this.data.forEach((item: CodeName) => {
            if (this.type === FilterType.SmallName && this.validationData.includes(item.name) && item.selected
                || this.type !== FilterType.SmallName && this.validationData.includes(item.code) && item.selected
            ){
                item.disabled = true;
            } else{
                item.disabled = false;
            }
        });
    }

    private onlyUniqueItems = (data: string): string => {

        let inputDataArr = this.getArrFromString(data);
        inputDataArr = this.helper.checkUniqueByObj(inputDataArr);
        // inputDataArr = inputDataArr.filter(this.onlyUnique);
        return this.getStringFromArr(inputDataArr);
    };

    private getNotValidateData = (): void => {
        let furtherData: CodeName[] = [];
        if (this.getFurtherData){
            furtherData = this.getFurtherData();
        }

        let selected = this.getArrFromString(this.inputData),
            stringObj = this.stringArrToObj(selected, this.type),
            commonData = furtherData.length ? this.data.concat(furtherData) : this.data,
            dataObj = this.arrToObj(commonData, this.type);


        // console.log(selected, stringObj, dataObj, 'getNotValidateData')
        this.notValidatedData = this.validateData(stringObj, dataObj);
        this.notValidatedDataShowScroll = this.notValidatedData.length > 0;
        this.filterService.setUpdateValidateData({GUID: this.GUID, param: this.param, data: this.notValidatedData});
        //this.notValidatedData = this.objToArr(dataObj);
    }

    private getNotValidateDataAdditionalData = async (additionalSelected: CodeName[]): Promise<void> => {
        let selected = this.getArrFromString(this.inputData),
            additionSelStrArr = this.type === FilterType.CodeName ? additionalSelected.map(item => item.code.trim()) : additionalSelected.map(item => item.name.trim());
        this.notValidatedData = this.validateAdditionalData(selected, additionSelStrArr);
        this.notValidatedDataShowScroll = this.notValidatedData.length > 0;
        this.filterService.setUpdateValidateData({GUID: this.GUID, param: this.param, data: this.notValidatedData});
    }

    private readonly showMessagesAlways = () => {
        if (this.alwaysShowGrid){
            this.notValidatedDataShowScroll = true;
            this._showGridByScroll = true;
            this.messageShowScroll = true;
        }

    }

    private setSelectedQuantity = (): void => {
        if (this.develop) console.log(this.data.filter(item => item.selected).length, 'setSelectedQuantity');
        this.selectedQuantity = this.data.filter(item => item.selected).length;
        this.selected = this.selectedQuantity > 0;
    };

    public addClickSelected = (codes: string[]): void => {
        let inputDataArr = this.getArrFromString(this.inputData);
        if (this.develop) console.log(inputDataArr, 'addClickSelected');
        inputDataArr = inputDataArr.concat(codes);
        inputDataArr = this.helper.checkUniqueByObj(inputDataArr);
        //codes.forEach(item => inputDataArr.splice(inputDataArr.length, 0, item));
        this.inputData = this.getStringFromArr(inputDataArr);
        this.updateDataSubscription(this.inputData);
    };

    public removeSelected = (codes: string[], updateSubscription: boolean = true): void => {

        let inputDataArr = this.getArrFromString(this.inputData);
        if (this.develop) console.log('work 1');
        inputDataArr = this.removeByObj(inputDataArr, codes);
        // inputDataArr = inputDataArr.filter(item => !codes.some(iItem => iItem.toLowerCase() === item.toLowerCase()));
        if (this.develop) console.log('work 2');
        this.inputData = this.getStringFromArr(inputDataArr);
        if (this.develop) console.log('work 3');
        updateSubscription && this.updateDataSubscription(this.inputData);

    };

    private getArrFromString = (data: string): string[] => {
        let multiple = this.getMainSeparator(data, this.separator);
        return multiple
            ? this.helper.multipleSeparate(data, this.separator)
            : this.helper.separate(data, this.separator[0]);
    };

    private getStringFromArr = (data: string[]): string => {
        return data.map((item, i) => i === 0 ? item : ' ' + item).join(this.separator[0]);
    };

    private getMainSeparator = (data: string, separator: string[]): boolean => {
        if (separator.length > 1){
            let res = separator.map(s => {
                return {dataLength: data.split(s).length, separator: s}
            });
            let sepQuantity = 0;
            res.sort(function (a, b){
                return b.dataLength - a.dataLength;
            }).forEach((item, i) => {
                separator[i] = item.separator;
                item.dataLength > 0 && sepQuantity++;
            });
            //console.log(res, separator, 'getMainSeparator')
            return sepQuantity > 1
        }

    }

    public clearDataFilter = (getAdditionalData: boolean = true) => {
        if (this.develop) console.log('clearDataFilter', this.param);
        this.data.forEach(item => item.selected = false);
        let inputData = !!this.inputData;
            this.prevInputData = '';

        this.inputData = '';
        this.showGrid = false;

        // this.addSelected();
        this.clearSearchFilter();
        this.setSelectedQuantity();
        this.setSelectedRows();
        this._showSearch = false;

        this.popper && this.popperObj ? this.popperObj.update() : this.gridTop = -1000;
        if (getAdditionalData && inputData){
            this.getAdditionalData()
        }
        this.getNotValidateData();
    };

    /*public updateData = () => {
        this.filtersState[this.param] = false;
        this.filterService.setFiltersState(this.filtersState);
        this.getData();
    }*/

    public clearSearchFilter = () => {
        if (this.develop) console.log('clearSearchFilter', this.param);
        this.searchData = '';
        this.filterSearch();

    };

    private handleKeys = (e: KeyboardEvent, keyDown: boolean): void => {

        if (this.plusPressed && this.plusPressed && !keyDown){
            if (this.focusActive || this.showGrid) console.log('ctrl+');
        }

        /*if (!keyDown && e.keyCode === 13){
            if (this.focusActive || this.showGrid || this._showSearch){
                this.addSelected();
                this.inputDataEl.nativeElement.focus();
                this._showSearch = false;
                this.clearSearchFilter();
            }
        }*/

        if (keyDown && e.keyCode === 9 && this.focusSearchActive && !this.showGrid){
            //e.preventDefault();
            //this.inputDataEl.nativeElement.focus();
            //this.focusSearchActive = false;
        }

        if (e.ctrlKey) this.ctrlPressed = keyDown;
        if (e.keyCode === 107) this.plusPressed = keyDown;

    };

    public inputDataWork = (e: KeyboardEvent, keyDown: boolean): void => {
        if (e && e.keyCode === 27 && !keyDown){
            //this.clearDataFilter();
            //this.prevInputDataUpdate = true;
            this._inputData = this.prevInputData;
            this.addSelected();
            this.setSelectedRows();
            //this.resizeGrid();
            //this.gridView.refresh();
            this.grid.invalidate();
            return;
        }

        if (e && !e.repeat){
            if (e.keyCode === 8 || e.keyCode === 46){
                //this.prevInputDataUpdate = false;
            }
        }

        if (e && e.keyCode === 13 && !keyDown){
            this.addSelected();
            //this._showSearch = false;
            //this.showGrid = false;
            this.prevInputData = this.inputData;
            this.clearSearchFilter();
            this.getAdditionalData();

        }

        if (e && e.keyCode === 9 && this.loading){
            e.preventDefault();
        }

        if (e && e.keyCode === 9 && e.repeat){
            e.preventDefault();
        } else if (e && e.keyCode === 9 && e.shiftKey){
            e.preventDefault();
            this.showGrid = false;
            this._showSearch = false;
            this.filterService.setGoToNextFilter2({GUID: this.GUID, focus: new Focus(this.param, 'prev')});

            //this.inputSearchEl.nativeElement.focus();
        }

        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17)) return;

    };

    public filterSearch = (e?: KeyboardEvent, keyDown?: boolean): void => {
        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17 || e.keyCode === 18)) return;

        if (e && e.keyCode === 27 && !keyDown){
            this.clearSearchFilter();
            return;
        }

        if (e && e.keyCode === 13 && !keyDown){
            this._showSearch = false;
            this.showGrid = false;
            this.clearSearchFilter();
            this.inputDataEl.nativeElement.focus();
            return;
        }

        /*if (e && e.keyCode === 9 && e.repeat) {
            e.preventDefault();
            return;
        }*/

        if (e && e.keyCode === 9 && this.loading){
            e.preventDefault();
            return;
        }

        if (e && e.keyCode === 9 && e.repeat){
            e.preventDefault();
            return;
        }

        if (e && e.keyCode === 9){
            // this.grid && this.grid.setFocus();
            return;
        }


        if (this.loading){
            this.lazySearch = true;
            return;
        }

        let data: string[] = [];
        if (this.searchData && !keyDown){
            data = this.searchData.split(' ').map(item => item.trim());
        }

        if (this.data && this.data.length > 0 && !keyDown){

            if (this.searchData && this.searchData.length > 0){
                this.filteredData = this.data.filter(item => {
                    if (this.type === FilterType.CodeName) item.findCode = this.helper.matchText(data, item.code);
                    item.findName = this.helper.matchText(data, item.name);
                    return item.findCode || item.findName;
                });
            } else{
                this.data.forEach(item => {
                    item.findCode = false;
                    item.findName = false;
                });
                this.filteredData = this.data;
            }

            if (e && !this.showGrid){
                this.showGrid = true;
            }

            this.filteredData.sort(function (a: any, b: any){
                return b.selected - a.selected;
            });

            //this.gridView.setItems([]);
            this.gridView.setItems(this.filteredData);
            this.gridView.refresh();

            if (this.type !== 4){
                this.grid.invalidate();
                this.grid.render();
            }
            if (this.type === FilterType.CodeName) this.setCellStyles();

            //this.syncSelected();
            this.setSelectedRows();
            if (this.develop) console.log(this.data.filter(item => item.selected), 'filterSearch');

        } else{

            //if(this.type !== 4) this.showGrid = false;
        }
        if (!keyDown){
            this.setSelectedQuantity();
        }


    };

    private addToRemovedCodes = (list: string[]) => {
        this.codesToRemove.push.apply(this.codesToRemove, list);
        this.codesToRemove = this.codesToRemove.filter(this.onlyUnique);
    };

    private removeFromRemovedCodes = (list: string[]) => {
        this.codesToRemove = this.codesToRemove.filter(item =>
            !list.some(iItem => iItem === item)
        )
    };

    private removeCodesInputData = (data: string[]) => {
        data.forEach((item, index, object) => {
            if (this.codesToRemove.some(iItem => iItem === item)){
                object.splice(index, 1);
            }
        });
    };

    private selectAll = (select: boolean): void => {
        this.filteredData.forEach(item => !item.disabled ? item.selected = select : null);
        let selected = this.filteredData.filter(item => !item.disabled),
            codes = this.type === FilterType.CodeName ? selected.map(item => item.code) : selected.map(item => item.name);
        select ? this.addClickSelected(codes) : this.removeSelected(codes);
        //select ? this.addToRemovedCodes(codes) : this.removeFromRemovedCodes(codes);
        this.gridView.setItems([]);
        this.gridView.setItems(this.filteredData);
        this.setSelectedRows();
        this.setSelectedQuantity();
    };

    private checkAllSelect = (): void => {
        let allSelected = this.filteredData.length > 0 ? this.filteredData.every(item => item.selected) : false;
        if (this.develop) console.log(allSelected, 'allSelected checkAllSelect - ' + this.param);
        //allSelected ? this.renderer.setAttribute(this.checkBoxHeader, 'checked', 'true') : this.renderer.removeAttribute(this.checkBoxHeader, 'checked');
        if (this.checkBoxHeader){
            allSelected ? this.checkBoxHeader.checked = true : this.checkBoxHeader.checked = false;
        }

    };

    public selectRow = (row: CodeName, node?: HTMLElement): void => {

        if (this.develop) console.log(this.data.filter(item => item.selected), 'selectRow');
        row.selected = !row.selected;
        if (this.type === FilterType.CodeName){
            !row.selected ? this.removeSelected([row.code]) : this.addClickSelected([row.code]);
        } else{
            !row.selected ? this.removeSelected([row.name]) : this.addClickSelected([row.name]);
        }

        /*this.data.forEach(item => {
            if (item.id === row.id) {
                item.selected ? this.removeSelected([item.code]) : this.addClickSelected([item.code]);
                //item.selected ? this.addToRemovedCodes([item.code]) : this.removeFromRemovedCodes([item.code]);
                item.selected = !item.selected;
            }
        });*/
        this.setSelectedRows();
        this.setSelectedQuantity();

    };


    public readonly onOrdersSelectedRowsChanged = (args: EventArgs<Slick.OnSelectedRowsChangedEventArgs<CodeName>>): void => {
        //console.log(args.data.rows.map(r => this.list.getItemByIdx(r)), 'onOrdersSelectedRowsChanged');
        // console.log(args);
    }

    private renderCheckBoxCell = (cellNode: HTMLElement, row: any, dataContext: CodeName) => {
        // let checkbox = cellNode.querySelector('input');
        console.log(row, 'renderCheckBoxCell');
        // this.renderer.listen(checkbox, 'click', () => this.selectRow(dataContext, checkbox));
    };


    private setSelectedRows = (): void => {
        let selected = this.filteredData.filter(item => item.selected);

        if (this.develop) console.log(this.filteredData.length, 'setSelectedRows this.filteredData.length', this.param);
        let id = selected.map(item => this.gridView.getRowById(item.id.toString()));
        this.setCellStyles();
        if (this.develop) console.log(selected, 'setSelectedRows', this.param);
        //if (this.grid) this.grid.setSelectedRows(id);

        /*let timeOut = setTimeout(() => {
            clearTimeout(timeOut);
            timeOut = null;
            //if (this.develop) console.log(selected, 'setSelectedRows', this.param);
            if (this.grid) this.grid.setSelectedRows(id);
        },100);*/

        this.checkAllSelect();
    };

    private setCellStyles = (): void => {
        let mainStyles = null;

        this.filteredData.forEach((row, i) => mainStyles = this.setCellMainStyles(mainStyles, row, i));
        const styles = {};
        if (mainStyles === null) mainStyles = {};
        styles['main-styles'] = mainStyles;
        this.cellCssStyles = styles;
        // console.log(this.cellCssStyles, 'styles')

    };

    private setCellMainStyles = (hash: Slick.CellCssStylesHash, row: CodeName, index: number): Slick.CellCssStylesHash => {
        let styles = null;

        if (row.findCode)
            styles = Object.assign({}, {code: 'found'});
        if (row.findName)
            styles = Object.assign(styles || {}, {name: 'found'});

        if (row['selected']){
            let styleObj = {};
            styleObj['code'] = 'selected';
            styleObj['name'] = 'selected';
            styleObj['selected'] = 'selected';
            styles = Object.assign(styles || {}, styleObj);
        }

        // console.log(row, row['selected'], styles)

        if (!styles)
            return hash;

        if (!hash)
            hash = {};
        hash[index] = styles;

        return hash;
    };

    public readonly onOrdersActiveCellChanged = (args: EventArgs<Slick.OnActiveCellChangedEventArgs<CodeName>>): void => {
        //console.log(args);
    }

    public onGridClick = (args: any): void => {
        // console.log(args, 'onGridClick');
        // this.helper.wait(() => {
        let data = this.gridView.getItem(args.data.row),
            el = args.event.target,
            row = args.data.row;

        /*const hasClass = (element: Element): boolean => {
            let classes = element.classList, rowEl;
            for (let i =  0; i < classes.length; i++ ) {
                if (classes[i] === 'slick-row'){
                    rowEl = true;
                }
            }
            return rowEl;
        };*/


        if (data.disabled || el.tagName.toLowerCase() === 'input'){
            return;
        }/* else {
            while (el){
                if (hasClass(el)) {
                    break;
                }
                el = el.parentElement;
            }
            el = el.querySelector('input');
        }*/

        this.selectRow(data);
        this.grid.updateRow(row);
        // }, 30)


    };

    public readonly onGridDblClick = (args: EventArgs<Slick.OnClickEventArgs<CodeName>>): void => {
        //console.log(args, 'onGridDblClick');
    };

    public readonly saveSort = (args: EventArgs<Slick.OnSortEventArgs<CodeName>>): void => {
        if (this.propsName){
            if (args){
                this.saveSortToLocalStorage({columnId: args.data.sortCols[0].sortCol.id, sortAsc: args.data.sortCols[0].sortAsc})
            } else {
                localStorage.removeItem(this.generateNameForDimensions(true));
            }
        }
    }

    public onGridKeyDown = (args: any): void => {
        if (args.event.keyCode === 32){
            this.onGridClick(args);
            // let data = this.gridView.getItemByIdx(args.data.row),
            //     row = args.data.row;
            // console.log(args,'onGridKeyDown 2');
            // let item = this.gridView.getItem(args.data.row);
            // if (this.type === 1){
            //     item.selected ? this.removeSelected([item.code]) : this.addClickSelected([item.code]);
            // } else{
            //     item.selected ? this.removeSelected([item.name]) : this.addClickSelected([item.name]);
            // }
            //
            // item.selected = !item.selected;


            // this.selectRow(data);
            // this.grid.updateRow(row);

        } else if (args.event.keyCode === 13){
            this._showSearch = false;
            this.showGrid = false;
            this.clearSearchFilter();
            //this.inputDataEl.nativeElement.focus();
            this.filterService.setGoToNextFilter2({GUID: this.GUID, focus: new Focus(this.param, 'next')});
        } else if (args.event.keyCode === 27){
            this.clearSearchFilter();
            this._showSearch = false;
        } else if (args.event.keyCode === 9 && args.event.originalEvent.shiftKey && args.event.originalEvent.repeat){
            args.event.originalEvent.preventDefault();
        } else if (args.event.keyCode === 9 && args.event.originalEvent.shiftKey){
            args.event.originalEvent.preventDefault();
            let timeOut = setTimeout(() => {
                clearTimeout(timeOut);
                timeOut = null;
                this.inputSearchEl.nativeElement.focus();
            }, 0);

        } else if (args.event.keyCode === 9 && args.event.originalEvent.repeat){
            args.event.originalEvent.preventDefault();
            this.inGrid = true
        } else if (args.event.keyCode === 9){
            //console.log(args.event);
            if (this.inGrid){
                this.clearSearchFilter();
                args.event.preventDefault();
                this._showSearch = false;
                this.showGrid = false;
                this.filterService.setGoToNextFilter2({GUID: this.GUID, focus: new Focus(this.param, 'next')});
            }
            this.inGrid = true
        }
    };

    public resizeGrid = (last?: boolean): void => {
        if (this.grid && this.mouseDown){
            if (this.timeOut){
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }

            this.timeOut = setTimeout(() => {
                this.columnWidth();
                this.grid.resizeGrid();
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }, 100);
        } else if (this.grid && last){
            this.columnWidth();
            this.grid.resizeGrid();
            this.setGridTop();
        }
    };

    private setColumnsProps = (): void => {
        let getSlickGridProp: GetSlickGridProp[] = [];
        getSlickGridProp.push(new GetSlickGridProp(this.columns, this.param));
        this.commonData.setSlickGridProp(getSlickGridProp, this.slickGridProp);
        this.columns = this.removeColumn(this.columns);
        if (this.grid){
            // console.log(this.columns, 'setColumnsProps')
            this.helper.wait(() => this.grid.setColumns(this.columns), 2);

        }
    };

    private setSlickGridProps = (): void => {
        this.commonData.saveUserProp.getSlickGridProperties('stocks', [this.param + 'Filter']).subscribe(prop => {
            this.slickGridProp = !prop.data ? [] : JSON.parse(prop.data);
            this.setColumnsProps();
        });
    };

    private removeColumn = (columns: any[]): any[] => {
        return columns.filter(item => !(this.type !== 1 && item.id === 'code'));
    };

    /*private translateData = async (data: CodeName[], translateService: TranslateService): Promise<CodeName[]> => {

        if (data && data.length > 0) {
            let names: string[] = data.map(item => item.name);
            let res: any = await this.commonData.translateService.get(names).toPromise();
            for (let i = 0; i < data.length; i++){
                data[i].name = res[data[i].name]
            }
            // data.forEach(item => {
            //     item.name = res[item.name]
            // });
        }
        return data;
    };*/

    private setGridTop = (): void => {
        if (this.showGrid){

            let modalBodyH = this.$modalBody.outerHeight(),
                filtersWrpH = this.$filtersWrp.outerHeight(),
                modalBodyP = parseInt(this.$modalBody.css("padding-bottom")),
                $mainWrapper = $(this.mainWrapper.nativeElement.parentElement),
                $gridWrp = $(this.gridWrpEl.nativeElement);

            let up = modalBodyH - $mainWrapper.position().top < $gridWrp.outerHeight();
            this.gridHeight = $gridWrp.outerHeight();
            // let up = modalBodyH - $mainWrapper.position().top < this.gridHeight;

            let show1 = modalBodyH - modalBodyP - filtersWrpH - $mainWrapper.position().top - $mainWrapper.outerHeight() < 0;
            let show2 = modalBodyH - $mainWrapper.position().top - $mainWrapper.outerHeight() > 0;

            if (!show1 || !show2){
                this.showGridByScroll = false;
            } else if (show1 && show2){
                this.showGridByScroll = true;
            }

            if (up){
                // this.gridTop = $mainWrapper.position().top - $gridWrp.outerHeight();
                this.popper ? this.popperObj.update() : this.gridTop = $mainWrapper.position().top - this.gridHeight;
            } else{
                this.popper ? this.popperObj.update() : this.gridTop = $mainWrapper.position().top + $mainWrapper.outerHeight();
            }
        } else{
            this.popper ? this.popperObj.update() : this.gridTop = -1000;
        }

    };

    private setMessageTop = (): void => {
        let modalBodyH = this.$modalBody.outerHeight(),
            filtersWrpH = this.$filtersWrp.outerHeight(),
            modalBodyP = parseInt(this.$modalBody.css("padding-bottom")),
            $mainWrapper = $(this.mainWrapper.nativeElement.parentElement);

        let show1 = modalBodyH - modalBodyP - filtersWrpH - $mainWrapper.position().top - 1 < 0;
        let show2 = modalBodyH - modalBodyP - $mainWrapper.position().top + 10 > 0;

        if (!show1 || !show2){
            this.messageShowScroll = false;
        } else if (show1 && show2){
            this.messageShowScroll = true;
        }

        this.showMessagesAlways();

        this.messageTop = $mainWrapper.position().top - 25;
    };

    private setNotValidateDataTop = (): void => {
        if (this.notValidatedData.length > 0){
            let modalBodyH = this.$modalBody.outerHeight(),
                filtersWrpH = this.$filtersWrp.outerHeight(),
                modalBodyP = parseInt(this.$modalBody.css("padding-bottom")),
                $mainWrapper = $(this.mainWrapper.nativeElement.parentElement);

            let show1 = modalBodyH - modalBodyP - filtersWrpH - $mainWrapper.position().top - 10 < 0;
            let show2 = modalBodyH - 2 * modalBodyP - $mainWrapper.position().top > 0;

            if (!show1 || !show2){
                this.notValidatedDataShowScroll = false;
            } else if (show1 && show2){
                this.notValidatedDataShowScroll = true;
            }

            this.showMessagesAlways();

            this.notValidatedDataTop = $mainWrapper.position().top + 5;
            this.notValidatedDataRight = $mainWrapper.width() - 120;
        }
    };

    private compareArr = (arr1: string[], arr2: string[]): boolean => {
        if (!arr1 || !arr2)
            return false;

        // compare lengths - can save a lot of time
        if (arr1.length != arr2.length)
            return false;

        for (let i = 0, l = arr1.length; i < l; i++){

            if (arr1[i].toLowerCase() !== arr2[i].toLowerCase()){
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;

    };

    private sortArr = (arr: string[]): string[] => {
        if (!arr) return [];
        return arr.sort();
    };

    private hideMessage = (name: string): void => {
        this.helper.wait( () => this[name] = false, this.hideMessageTime);

    };

    private columnWidth = (): void => {
        let width = this.gridWrpEl.nativeElement.offsetWidth - 7;
        //let height = this.gridWrpEl.nativeElement.offsetHeight - 5;
        let stringQuantity = Math.floor((this.gridHeight - 5) / 25) - 1;
        // console.log(width, 'width 1');
        if (this.filteredData.length > stringQuantity){
            width = width - this.slickScrollWidth;
        }
        // console.log(width, this.filteredData.length, stringQuantity, 'width 2');
        //let columns = this.grid.getColumns();
        this.columns.forEach(item => {
            if (item.field !== 'name'){
                width = width - item.width;
            }
        });
        // console.log(width, 'width 3');

        this.columns.forEach(item => {
            if (item.field === 'name'){
                item.width = width;
            }
        });

        // console.log(width, 'width 4');



        // this.grid.setColumns(this.columns);
        this.grid.resizeGrid();
        this.grid.autosizeColumns(this.columns);
        // this.grid.invalidate();
        // this.grid.resizeCanvas();
        // this.grid.render();

        // this.gridView.refresh()
        this.setDimensions({
             width: this.gridWrpEl.nativeElement.offsetWidth,
             height: this.gridWrpEl.nativeElement.offsetHeight
        })

        //this.checkAllSelect();
    };

    private readonly generateNameForDimensions = (sort: boolean = false): string => {
        return this.propsName.moduleName + this.propsName.tableName + 'Filter' + (sort ? 'Sort' : '');
    }

    private readonly applyDimensions = ():void => {
        if (this.propsName){
            let dimensions: { width: number, height: number },
                res = localStorage.getItem(this.generateNameForDimensions());
            res ? dimensions = JSON.parse(res) : null;

            if (dimensions){
                this.gridWidth = dimensions.width;
                this.gridHeight = dimensions.height;
            }
        }
    }

    private readonly setDimensions = (dimensions: { width: number, height: number }):void => {
        if (this.propsName){
            localStorage.setItem(
                this.generateNameForDimensions(),
                JSON.stringify(dimensions)
            )
        }
    }

    private readonly saveSortToLocalStorage = (sort: { columnId: string, sortAsc: boolean }):void => {
        if (this.propsName){
            localStorage.setItem(
                this.generateNameForDimensions(true),
                JSON.stringify(sort)
            )
        }
    }

    /*private readonly applySortFromLocalStorage = ():void => {
        if (this.propsName){
            let sort: { column: string, ask: boolean },
                res = localStorage.getItem(this.generateNameForDimensions(true));
            res ? sort = JSON.parse(res) : null;

            if (sort){
                console.log(this.generateNameForDimensions(true), this.generateNameForDimensions(), sort, 'applySortFromLocalStorage');
            }
        }
    }*/

    private calculateHeightForGrid = (): void => {
        this.gridHeight = 32;
        /*if (this.data.length === 1) {
            this.gridHeight += 25 * this.data.length;
        } else*/
        if (this.data.length < 12){
            this.gridHeight += 25 * this.data.length;
        } else{
            this.gridHeight = 270;
        }
    };

    public setValidateResult = (valRes: boolean, prop: string): void => {

    }

    // public readonly gridReady = (val: boolean): void => {
    //     val && this.applySortFromLocalStorage()
    // }

}




// WEBPACK FOOTER //
// ./src/app/stocks/components/filter-search-code-name.component/filter-search-code-name.component.ts